import './_message.scss';
import React from 'react';
import { Well, Button, ButtonGroup, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Text from './Text';

import { formatedFileName } from '../../../../../components/FileUploader/helpers';

const Message = ({ info, prepareConfirm, onOpenModal, readStatus, ticketID }) => {
  const { username, created, message, is_admin, access, id, files, additional } = info;

  return (
    <div className={`ticket-message ${is_admin ? 'my' : 'not-my'}`}>
      <div className="ticket-message__head">
        <strong>{username}</strong>
        <div>
          <p className="ticket-message__head-date">{created}</p>
        </div>
      </div>
      <div className={`ticket-message__body ${is_admin ? 'self' : 'not-self'}`}>
        <Well
          className={`ticket-message__body-message ${is_admin ? 'ticket-message__body-message--green' : 'ticket-message__body-message--blue'}`}
          bsSize="sm"
        >
          <div className="ticket-message__body-message--text">
            <Text message={message} additional={additional} />
          </div>
          <div
            className={classNames({
              'ticket-message__body-message--files': !!files?.length,
            })}
          >
            {files?.map((file) => (
              <a href={file.url} key={file.url + file.name} target="_blank" rel="noopener noreferrer nofollow">
                {formatedFileName(file.name)}
              </a>
            ))}
          </div>
        </Well>
      </div>
      {is_admin && (access.delete || access.edit || readStatus) ? (
        <Row className="ticket-message__footer">
          <Col xs={12}>
            <ButtonGroup>
              {!!access.edit && (
                <Button
                  bsStyle="link"
                  bsSize="xsmall"
                  onClick={() => onOpenModal('edit', {
                    message,
                    id,
                  })}
                >
                  Edit
                </Button>
              )}

              {!!access.delete && !!access.edit && <span className="ticket-message__footer-dot" />}

              {!!access.delete && (
                <Button
                  bsStyle="link"
                  bsSize="xsmall"
                  className={`ticket-message__footer__link ${!!access.delete && !!access.edit ? 'ticket-message__footer-link--edit' : ''}`}
                  onClick={() => prepareConfirm({ key: 1, title: 'Delete message', id, ticketID })}
                >
                  Delete
                </Button>
              )}
            </ButtonGroup>
            <p className="ticket-message__footer-status">{readStatus ? 'Message unread' : ''}</p>
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

Message.propTypes = {
  info: PropTypes.object,
  prepareConfirm: PropTypes.func,
  onOpenModal: PropTypes.func,
  readStatus: PropTypes.bool,
  ticketID: PropTypes.number,
};

export default Message;
